export default __webpack_public_path__ + "static/media/ic_tlp_40.d95bc4df.svg";